module.exports = __webpack_public_path__ + "img/meal-256.ce67ebfa.jpg";